import { DropDownCategories } from 'src/types/generic';

export const languageCodes = {
  '1033': 'en',
  '4105': 'ca',
  '17418': 'es',
  '1036': 'fr',
};
export const LanguageCategories: DropDownCategories[] = [
  { value: 1033, label: 'en' },
  { value: 4105, label: 'ca' },
  { value: 17418, label: 'es' },
  { value: 1036, label: 'fr' },
];
